import { BasicConstants } from "../../constants/BasicConstants";

/**
 * Created with IntelliJ IDEA.
 * User: Felix
 * Date: 13.07.12
 * Time: 11:22
 */


export class FacebookSettings {
    public static FACEBOOK_JS_PATH: string = BasicConstants.DOMAIN_PROTOCOL + "://media.goodgamestudios.com/sns/lib/ext/fbLogin.js";
    public static FACEBOOK_JS_LOGIN_METHOD: string = "fbLogin";
    public static FACEBOOK_CALLBACK_NAME: string = "fbLoginCallback";
}

